export default __webpack_public_path__ + "static/media/sb-ICO-06.b740c57d.webp";